var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompetition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 0H4.0684C1.82148 0 0 1.82148 0 4.0684V19.9316C0 22.1785 1.82148 24 4.0684 24H19.9316C22.1785 24 24 22.1785 24 19.9316V4.0684C24 1.82148 22.1785 0 19.9316 0Z",
    fill: "#91231F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_254_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 15,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3549 5.41943H5.41943V19.3549H19.3549V5.41943Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_254_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.32266L17.6594 5.73008L12.3872 5.41943L7.11492 5.73298L7.52427 8.32552H5.41943V8.61585C5.41943 12.2594 8.35463 15.2294 11.9837 15.2904C11.6294 16.2543 10.4972 18.7771 8.32266 18.7771V19.3578H16.4517V18.7771C14.2771 18.7771 13.145 16.2543 12.7907 15.2904C16.4197 15.2294 19.3549 12.2594 19.3549 8.61585V8.32552H17.25V8.32266ZM12.3872 6.00008L16.9859 6.27298L16.4604 9.59714C16.0713 12.0591 14.6314 14.7098 12.3872 14.7098C10.143 14.7098 8.74653 12.1404 8.31391 9.59714L7.78847 6.27298L12.3872 6.00008ZM6.00589 8.9033H7.61718L7.74201 9.69004C8.13391 12.001 9.00782 13.4758 9.99786 14.3294C7.75363 13.502 6.12492 11.4001 6.00589 8.9033ZM14.582 18.7743H10.1953C11.3333 18.0165 12.0359 16.6868 12.39 15.8449C12.7414 16.6868 13.4439 18.0165 14.5849 18.7743H14.582ZM14.762 14.3352C15.9756 13.2581 16.7566 11.4291 17.0323 9.68718L17.1572 8.9033H18.7685C18.6494 11.4059 17.0149 13.5136 14.7649 14.3352H14.762Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetition);
export default __webpack_public_path__ + "static/media/competition.2edfc9ab8b4c3a12ad1c7c1c98207988.svg";
export { ForwardRef as ReactComponent };